export default "__VITE_ASSET__2526377b__"